<script lang="ts">
    import Title from "../Components/Title.svelte";
    import {onMount} from "svelte";
    import GenericLoading from "../Modals/GenericLoading.svelte";
    import {alertShown, modalComponent, payslipData} from "../Core/Store";
    import {handApi} from "../Core/HandApi";
    import {PayslipData} from "../Data/PayslipData";
    import GenericError from "../Modals/GenericError.svelte";
    let localPayslipData:PayslipData[] = [];

    onMount(async () => {
        modalComponent.set(GenericLoading);
        alertShown.set(true);

        if ($payslipData !== null) {
            localPayslipData = $payslipData;
            alertShown.set(false);
        }

        // Load in new payslip data anyway
        let results = await handApi.getPayslipData();

        if (results === null) {
            modalComponent.set(GenericError);
            return;
        }

        payslipData.set(results);
        localPayslipData = $payslipData;
        alertShown.set(false);
    });

    async function download(url) {
        if (url.includes('https')) {
            window.open(url);
        } else {
            window.open(handApi.mainUrl + url);
        }
    }
</script>

<div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    <Title textColor="text-hand-green-500">
        <svg slot="icon" xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
            <path d="M9.707 7.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L13 8.586V5h3a2 2 0 012 2v5a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2h3v3.586L9.707 7.293zM11 3a1 1 0 112 0v2h-2V3z" />
            <path d="M4 9a2 2 0 00-2 2v5a2 2 0 002 2h8a2 2 0 002-2H4V9z" />
        </svg>
        <span>
            Payslips
        </span>
    </Title>

    {#each localPayslipData as payslip}
        <div class="pl-4 pr-6 py-4 mb-2 bg-white shadow rounded cursor-pointer" on:click={() => download(payslip.fileUrl)}>
            <div class="grid grid-cols-2 mb-2">
                <h4 class="text-sm font-medium">{payslip.taxPeriod} - Paid {payslip.datePayment.getDate()}/{payslip.datePayment.getMonth()}/{payslip.datePayment.getFullYear()}</h4>
                <div class="flex justify-end items-center space-x-2 text-sm font-medium">
                    <svg xmlns="http://www.w3.org/2000/svg" class="text-hand-blue-500 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                    </svg>
                    <span>Download</span>
                </div>
            </div>
            <div class="flex items-center justify-between">
                <div class="text-2xl font-medium">
                    Paid &pound;{payslip.net}
                </div>
                <div class="text-sm">
                    Gross: &pound;{payslip.gross}<br />
                    Tax: &pound;{payslip.tax}<br />
                    NI: &pound;{payslip.nationalInsurance}<br />
                    Pension: &pound;{payslip.pensionContributions}
                </div>
            </div>
        </div>
    {/each}
</div>